import { Icon } from '@iconify/react'
import { useStorefrontContent } from '@/branding/BrandingProvider'

export function AdinaAISection() {
  const { adina } = useStorefrontContent()

  return (
    <section id="adina" className="py-24 bg-slate-50 border-b border-slate-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-16">
        {/* Text Content */}
        <div className="flex-1 text-center lg:text-left reveal-base">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-slate-200 text-sm font-medium text-slate-600 mb-6">
            <Icon icon="solar:stars-linear" className="text-rust" />
            {adina.badge}
          </div>
          <h2 className="text-4xl lg:text-5xl font-medium tracking-tight text-navy mb-6">
            {adina.title} <br />
            {adina.titleLine2}
          </h2>
          <p className="text-lg text-slate-600 font-light mb-8 max-w-lg mx-auto lg:mx-0">
            {adina.description}
          </p>
          <ul className="space-y-4 max-w-lg mx-auto lg:mx-0">
            {adina.features.map((feature, i) => (
              <li key={i} className="flex items-center gap-3 text-slate-700">
                <div className="w-6 h-6 rounded-full bg-rust/10 text-rust flex items-center justify-center shrink-0">
                  <Icon icon={i === 0 ? 'solar:check-read-linear' : 'solar:document-add-linear'} />
                </div>
                <span className="font-light">{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Mobile Chat Mockup */}
        <div className="flex-1 flex justify-center w-full reveal-scale delay-200">
          <div className="w-full max-w-[340px] h-[640px] bg-white rounded-[3rem] shadow-2xl overflow-hidden border-[6px] border-slate-200 flex flex-col relative">
            {/* App Header */}
            <div className="bg-navy text-white pt-10 pb-4 px-6 relative z-20">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center border border-white/20">
                  <Icon icon="solar:user-speak-linear" className="text-xl text-rust" />
                </div>
                <div>
                  <h3 className="font-medium text-base tracking-tight leading-tight">{adina.assistantName}</h3>
                  <span className="text-xs text-white/60 font-light flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-400" /> Online
                  </span>
                </div>
              </div>
            </div>

            {/* Chat Area */}
            <div className="flex-1 bg-slate-50 p-5 overflow-y-auto flex flex-col gap-4 text-sm font-light">
              {adina.chat.map((msg, i) =>
                msg.sender === 'adina' ? (
                  <div key={i} className="flex gap-2 max-w-[85%]">
                    <div className="w-6 h-6 rounded-full bg-navy flex items-center justify-center shrink-0 mt-1">
                      <Icon icon="solar:stars-linear" className="text-white text-[10px]" />
                    </div>
                    <div className="bg-white border border-slate-200 p-3 rounded-2xl rounded-tl-sm text-slate-700 shadow-sm">
                      {msg.text}
                    </div>
                  </div>
                ) : (
                  <div key={i} className="flex gap-2 max-w-[85%] self-end flex-row-reverse">
                    <div className="bg-navy text-white p-3 rounded-2xl rounded-tr-sm shadow-sm">
                      {msg.text}
                    </div>
                  </div>
                ),
              )}

              {/* System Note overlay */}
              <div className="mt-auto relative z-10 animate-float-delayed">
                <div className="bg-white/90 backdrop-blur-sm border border-rust/30 rounded-xl p-3 shadow-lg flex items-start gap-3">
                  <Icon icon="solar:document-text-linear" className="text-rust text-lg mt-0.5" />
                  <div>
                    <div className="text-xs font-medium text-navy tracking-tight">{adina.autoChart.title}</div>
                    <div className="text-[10px] text-slate-500 mt-0.5">{adina.autoChart.description}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Input Area */}
            <div className="p-4 bg-white border-t border-slate-100">
              <div className="bg-slate-100 rounded-full h-10 flex items-center px-4 text-slate-400 text-sm">
                Type a message...
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
